const n = "_required_bndkv_141", r = {
  "field-container": "_field-container_bndkv_1",
  "label-container": "_label-container_bndkv_7",
  "input-container": "_input-container_bndkv_16",
  "radio-group": "_radio-group_bndkv_89",
  "radio-container": "_radio-container_bndkv_97",
  required: n,
  "no-arrows": "_no-arrows_bndkv_146"
};
export {
  r as default,
  n as required
};
